export default __webpack_public_path__ + "static/media/Measurement_Simulation.3e9eeb4a.png";